import React from "react";
//import { useReducer } from 'react'
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { DashboardRoutes } from "./DashboardRoutes";
//import { Context, globalState, generalReducer } from '../context'

import PrivateRoute from "../routers/PrivateRoute";
//import { useProvideAuth, AuthContext } from '../hooks/useAuth'
import "../App.css";
import Login from "../views/login/login";
import ForgotPassword from "../views/login/forgotPassword";
import ResetPassword from "../views/login/resetPassword";
import Prueba from "../views/otraVista/prueba";
import NoPermitido from "../layouts/sinPermiso";
import Presentation from "../views/landing/presentation";
import { TermsPage, PrivacyPage, RefundsPage } from "../views/legal/LegalPage";
import ContactSalesPage from "../views/contact/ContactSalesPage";

const AppRouter = () => {
  return (
    <Router>
      <Routes>
          <Route path="/" element={<Presentation />} />
          <Route path="/terminos" element={<TermsPage />} />
          <Route path="/privacidad" element={<PrivacyPage />} />
          <Route path="/reembolsos" element={<RefundsPage />} />
          <Route path="/contacto-ventas" element={<ContactSalesPage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/registro" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/test" element={<Prueba />} />
          <Route path="/not-allowed" element={<NoPermitido />} />
          <Route
            path="/*"
            element={
              <PrivateRoute>
                <DashboardRoutes />
              </PrivateRoute>
            }
          />
      </Routes>
    </Router>
  );
};

export default AppRouter;
